<template>
  <Button
    type="solid"
    variant="blue"
    :text="buttonText"
    icon="general.plus"
    :disabled="isDisabled"
    @click="openAddModal"
    data-testid="add-request-content-button"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { Button } from '@/storybook';
import { useRequestContentModals } from '../../composables/useRequestContentModals';
import { useRequestContentStore } from '@/store/useRequestContentStore';
import { useUserStore } from '@/store/useUserStore';

interface Props {
  buttonText?: string;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  buttonText: 'Create request link',
  disabled: false,
});

// Stores
const requestContentStore = useRequestContentStore();
const userStore = useUserStore();
const { domain } = storeToRefs(requestContentStore);
const { isOrgUserViewOnly } = storeToRefs(userStore);

// Disable button for view-only users
const isDisabled = computed(() => props.disabled || isOrgUserViewOnly.value);

// Modals
const { showAddModal } = useRequestContentModals();

const openAddModal = () => {
  return showAddModal({
    domain: domain.value,
    onSave: async () => {
      // Save is handled in the modal itself
    },
  });
};
</script>
